import get from "lodash/get";
import qs from "qs";
import moment from "moment";
import cmsInstance from "./axios-instances/cms";
import { ONLINE, PAN } from "@/store/actions/registeredEventsActions";

const filterEventsFromListing = (result, now) => {
        const data = result.data;
        data.data = data.data.filter(({ attributes }) =>
          moment(attributes.endTime || undefined).isAfter(now)
        );
        let total = data.meta.pagination.total;
        total = total - (total - data.data.length);
    
        data.meta.pagination = {
          ...data.meta.pagination,
          total,
          pageCount: Math.ceil(total / data.meta.pagination.pageSize),
        };

  return data;
};

export function fetchUpcomingEvents(profileData) {
  const now = moment(),
    endTime = now.clone().startOf("hour");
  if (now.minutes() >= 30) endTime.add(30, "minutes");

  const matchAnyFilters = [{ eventType: { $eq: ONLINE } }, { city: { name: { $eqi: PAN } } }];
  if (get(profileData, "address.city")) {
      matchAnyFilters.push({ city: { name: { $eqi: get(profileData, "address.city") } } });
  } else {
      matchAnyFilters.push({ city: { id: { $notNull: true } } });
  }

  const matchAllFilters = [
      { $or: matchAnyFilters },
      { endTime: { $gt: endTime.toISOString() } },
      { showOnListingPage: { $eq: true } },
  ];
  if ((get(profileData, "desired_profile.interest_countries") || []).length > 0) {
      matchAllFilters.push({
          countries: { name: { $in: get(profileData, "desired_profile.interest_countries") } },
      });
  } else {
    matchAllFilters.push({ countries: { id: { $notNull: true } } });
  }

  let query = {
    filters: { $and: matchAllFilters },
    sort: "dateTime:ASC",
    populate: ["image", "city", "form"],
    descriptionAsHTML: true,
    cache: true,
  };
  query = qs.stringify(query, { encodeValuesOnly: true });
  return cmsInstance.get(`/event-pages?${query}`).then((result) => {
    result.data = filterEventsFromListing(result, now);
    return result;
  });
}

export function getCMSGlobalData() {
  const query = qs.stringify({ populate: "deep" }, { encodeValuesOnly: true });
  return cmsInstance.get(`/global-contents?${query}`);
}
